export const paxLogo = (index) => {
  if(index.submitSucceeded) return 'completed';
  if(index.submitFailed) return 'error';
  return 'default';
}

export const paxStatus = (index) => {
  if(index.submitSucceeded) return 'Confirmed';
  if(index.submitFailed) return 'Complete information';
  return 'Complete information';
}



// WEBPACK FOOTER //
// ./src/helpers/passengerHelper.js